import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "checkbox-input" }
const _hoisted_2 = {
  key: 0,
  class: "skeleton-wrapper",
  "data-test": "skeleton-wrapper"
}

import {
  getCurrentInstance,
  ref,
  onMounted,
} from "vue";
import { IonCheckbox, IonLabel, IonItem, IonSkeletonText } from "@ionic/vue";

interface Props {
  checked: boolean;
  labelText: string;
  disabled: boolean;
  isLoading?: boolean;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
    checked: { type: Boolean },
    labelText: {},
    disabled: { type: Boolean, default: false },
    isLoading: { type: Boolean, default: false }
  },
  setup(__props: any) {



const uid = ref<number | null | undefined>(null);
onMounted(() => {
  uid.value = getCurrentInstance()?.uid;
  setTimeout(() => {
    // ion-checkbox has accessibility issues and this needs to be done to solve them
    const checkboxInput = document.querySelector(
      `#checkbox-input-${uid.value}`
    );
    if (checkboxInput?.shadowRoot) {
      const elements = checkboxInput.shadowRoot.querySelectorAll("*");
      elements.forEach((element) => {
        element.setAttribute("aria-hidden", "true");
      });
    }
  }, 500);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(IonSkeletonText), {
            animated: true,
            class: "skeleton-checkbox"
          }),
          _createVNode(_unref(IonSkeletonText), {
            animated: true,
            class: "skeleton-detail"
          })
        ]))
      : (_openBlock(), _createBlock(_unref(IonItem), {
          key: 1,
          lines: "none"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCheckbox), {
              slot: "start",
              checked: __props.checked,
              disabled: __props.disabled,
              onIonChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onChange', $event.detail.checked))),
              "data-test": "checkbox-input",
              id: `checkbox-input-${uid.value}`,
              "aria-checked": __props.checked,
              "aria-labelledby": `checkbox-label-${uid.value}`
            }, null, 8, ["checked", "disabled", "id", "aria-checked", "aria-labelledby"]),
            _createVNode(_unref(IonLabel), {
              id: `checkbox-label-${uid.value}`,
              class: "checkbox-label",
              "data-test": "checkbox-label",
              "aria-hidden": "true"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(__props.labelText), 1)
              ]),
              _: 1
            }, 8, ["id"])
          ]),
          _: 1
        }))
  ]))
}
}

})